var _path, _path2, _g, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _g2, _g3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg404(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 720,
    height: 430,
    viewBox: "0 0 720 430",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M359.548 380.702C340.513 380.702 324.107 376.192 310.329 367.173C296.55 358.082 285.932 345.049 278.475 328.075C271.018 311.029 267.325 290.539 267.396 266.604C267.467 242.67 271.195 222.357 278.582 205.667C286.039 188.906 296.621 176.157 310.329 167.421C324.107 158.614 340.513 154.211 359.548 154.211C378.582 154.211 394.988 158.614 408.766 167.421C422.616 176.157 433.269 188.906 440.726 205.667C448.184 222.428 451.877 242.741 451.806 266.604C451.806 290.61 448.077 311.136 440.62 328.181C433.163 345.227 422.545 358.259 408.766 367.279C395.059 376.228 378.653 380.702 359.548 380.702Z",
    fill: "#E6E6F0"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1312_18097",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 266,
    y: 10,
    width: 249,
    height: 371
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M359.547 380.702C340.513 380.702 324.107 376.193 310.328 367.173C296.55 358.082 285.932 345.049 278.475 328.075C271.017 311.029 267.324 290.539 267.395 266.604C267.433 253.764 268.524 241.966 270.668 231.211C272.52 221.918 263.971 202.447 267.395 194.711C274.853 177.95 296.621 31.946 310.328 23.2102C324.107 14.4034 340.513 9.99997 359.547 9.99997C378.581 9.99997 394.988 14.4034 408.766 23.2102C422.615 31.946 577.395 22.2109 485.395 145.711C488.215 152.051 445.829 218.855 447.573 226.211C450.439 238.303 451.85 251.767 451.806 266.604C451.806 290.61 448.077 311.136 440.62 328.181C433.162 345.227 422.544 358.259 408.766 367.279C395.059 376.228 378.652 380.702 359.547 380.702Z",
    fill: "black"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1312_18097)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M319.89 321.57V267.461L326.077 260.015V205.591L331.425 200.453L335.724 199.404L334.256 332.266L319.89 321.57Z",
    fill: "url(#paint0_linear_1312_18097)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.178 369.912L356.697 356.805L358.061 255.507L369.281 245.23L382.808 219.643L385.954 219.434L378.509 372.429H341.178V369.912Z",
    fill: "url(#paint1_linear_1312_18097)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.941 208.107L419.93 216.077V221.74L415.631 229.604V375.679H427.376L430.941 208.107Z",
    fill: "url(#paint2_linear_1312_18097)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.558 202.34H279.622V369.807H282.558V202.34Z",
    fill: "#CCE5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.206 202.34H289.27V369.807H292.206V202.34Z",
    fill: "#CCE5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.077 267.67H392.979V271.235H395.077V267.67Z",
    fill: "#CCE5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.962 291.055H381.864V294.62H383.962V291.055Z",
    fill: "#CCE5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.882 260.016H388.785V263.581H390.882V260.016Z",
    fill: "#CCE5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.958 202.34H299.021V369.807H301.958V202.34Z",
    fill: "#CCE5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.711 202.34H308.774V369.807H311.711V202.34Z",
    fill: "#CCE5E5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M301.958 171.406L270.395 213.561V215.554H278.259L445.516 193.428L451.179 187.031H357.221V179.9L359.843 177.593L301.958 171.406Z",
    fill: "url(#paint3_linear_1312_18097)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M304.684 402L301.958 188.289H444.362L435.973 402",
    fill: "url(#paint4_linear_1312_18097)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M304.935 401.666L304.096 176L274 212.807L275.154 388.558L304.935 401.666Z",
    fill: "url(#paint5_linear_1312_18097)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M304.839 401.666L304 176L316.898 176.629L317.213 178.936L342.275 179.46L346.26 177.573L357.375 177.992L354.23 401.666",
    fill: "url(#paint6_linear_1312_18097)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M435.974 402L436.917 371.8H354.39V369.598H304.37L304.685 402",
    fill: "#CBCBD6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M304.685 402L304.37 369.598H354.39L354.075 402",
    fill: "url(#paint7_linear_1312_18097)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M304.684 402L304.369 369.598L274.798 371.066L274.903 389.731L304.684 402Z",
    fill: "url(#paint8_linear_1312_18097)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M436.917 370.436L354.39 371.799V373.267L438.49 372.533L436.917 370.436Z",
    fill: "#ECECEC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M438.49 372.533L436.917 375.994L354.39 375.26V372.533H438.49Z",
    fill: "#C1C1CB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M300.91 369.598L304.371 371.8L354.39 371.275L357.222 369.598H300.91Z",
    fill: "#C9C9D5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M304.685 366.871L274.799 368.863L271.968 370.751L274.799 372.534L304.371 371.8L302.798 369.598L304.685 366.871Z",
    fill: "#E06456"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M320.52 402V373.268H337.088L336.564 402",
    fill: "#C3C3CF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M320.52 402V373.268H334.991L334.362 402",
    fill: "#E6E6F0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M321.358 394.45V374.211H333.942L333.627 394.45",
    fill: "url(#paint9_linear_1312_18097)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M337.088 373.268L334.886 376.728L320.52 380.713V373.268H337.088Z",
    fill: "#80808D",
    fillOpacity: 0.49
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M342.121 179.794L317.059 179.27V366.87H340.443L342.121 179.794Z",
    fill: "url(#paint10_linear_1312_18097)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.179 183.15H357.222V187.03H451.179V183.15Z",
    fill: "url(#paint11_linear_1312_18097)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M359.843 172.979V177.593L301.958 175.286V171.406L359.843 172.979Z",
    fill: "url(#paint12_linear_1312_18097)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M322.51 354.832V329.141H336.352L335.408 354.832H322.51Z",
    fill: "#C3C3CF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M322.51 329.645H335.093L334.569 354.497H322.51V329.645Z",
    fill: "#F6F6FA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M334.36 330.168L333.731 353.448H323.035V330.168H334.36Z",
    fill: "url(#paint13_linear_1312_18097)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.941 346.631H323.035V347.47H333.941V346.631Z",
    fill: "#F6F6FA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M336.352 328.805L334.254 332.475H322.51V328.805H336.352Z",
    fill: "#80808D",
    fillOpacity: 0.49
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M322.51 311.209V285.518H336.352L335.408 311.209H322.51Z",
    fill: "#C3C3CF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M322.51 286.021H335.093L334.569 310.874H322.51V286.021Z",
    fill: "#E6E6F0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M334.36 286.545L333.941 303.008V303.113L333.731 309.929H323.035V286.545H334.36Z",
    fill: "url(#paint14_linear_1312_18097)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.941 303.008H323.035V303.847H333.941V303.008Z",
    fill: "#E6E6F0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M336.352 285.182L334.254 288.852H322.51V285.182H336.352Z",
    fill: "#80808D",
    fillOpacity: 0.49
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M322.51 267.692V242H336.352L335.408 267.692H322.51Z",
    fill: "#C3C3CF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M322.51 242.398H335.093L334.569 267.356H322.51V242.398Z",
    fill: "#E6E6F0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M334.36 243.027L334.151 252.57L333.731 266.307H323.035V243.027H334.36Z",
    fill: "url(#paint15_linear_1312_18097)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.941 259.49H323.035V260.329H333.941V259.49Z",
    fill: "#E6E6F0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M336.352 241.664L334.254 245.229H322.51V241.664H336.352Z",
    fill: "#80808D",
    fillOpacity: 0.49
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M322.51 221.426V195.734H336.352L335.408 221.426H322.51Z",
    fill: "#C3C3CF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M322.51 196.574H335.093L334.569 221.427H322.51V196.574Z",
    fill: "#E6E6F0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M334.36 197.098L334.256 199.405V199.509L333.731 220.377H323.035V197.098H334.36Z",
    fill: "url(#paint16_linear_1312_18097)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.941 213.561H323.035V214.399H333.941V213.561Z",
    fill: "#E6E6F0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M336.352 195.734L334.254 199.405H322.51V195.734H336.352Z",
    fill: "#80808D",
    fillOpacity: 0.49
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M344.114 366.872L346.106 177.908L342.121 179.796L340.443 366.872H344.114Z",
    fill: "url(#paint17_linear_1312_18097)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M419.928 353.867L420.767 328.805H371.482L371.167 353.867H419.928Z",
    fill: "#C3C3CF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M371.483 331.217L370.959 355.44L415.211 354.706L415.945 331.217H371.483Z",
    fill: "url(#paint18_linear_1312_18097)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter0_f_1312_18097)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M371.168 344.324L368.966 364.458L415.211 363.514L416.574 358.166H370.958L371.168 344.324Z",
    fill: "#8C8C95"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M416.679 330.377H371.483V331.216H387.736L387.243 355.169L370.959 355.439V355.964L387.232 355.735L387.212 356.698H387.736L387.76 355.728L415.84 355.334L416.679 330.377ZM387.774 355.16L388.365 331.216H403.362L402.732 354.912L387.774 355.16ZM403.362 354.902L415.211 354.705L415.575 343.061L403.682 342.858L403.362 354.902ZM403.698 342.229L403.991 331.216H415.945L415.595 342.432L403.698 342.229Z",
    fill: "#E6E6F0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M419.928 310.14L420.767 285.078H371.482L371.167 310.14H419.928Z",
    fill: "#C3C3CF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M371.483 287.596L370.959 311.819L415.211 310.98L415.945 287.596H371.483Z",
    fill: "url(#paint19_linear_1312_18097)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter1_f_1312_18097)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M371.168 300.598L368.966 320.731L415.211 319.788L416.574 314.544H370.958L371.168 300.598Z",
    fill: "#8C8C95"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M416.679 286.756H371.483V287.595H415.945L415.593 298.811L403.697 298.608L403.991 287.595H403.362L402.732 311.189H403.362L403.683 299.132L415.577 299.335L415.211 310.979L387.775 311.499L388.365 287.595H387.736L387.244 311.509L370.959 311.818V312.343L387.232 312.076L387.212 313.077H387.736L387.761 312.068L415.84 311.608L416.679 286.756Z",
    fill: "#E6E6F0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M423.494 301.122L422.76 314.544H375.467V300.598L423.494 301.122Z",
    fill: "url(#paint20_linear_1312_18097)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M375.468 300.598H371.169L370.959 314.544H375.468V300.598Z",
    fill: "#BFBFCB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M375.467 307.309H389.833V311.293L375.467 311.818V307.309Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M393.295 300.809L394.134 306.891L416.575 307.31V301.018L393.295 300.809Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M357.22 179.899L346.105 181.158L341.805 185.142L317.058 187.03V179.27H303.845L273.749 216.497V213.141L303.845 176.334L316.743 176.963L317.058 179.27L342.12 179.794L346.105 177.907L357.22 178.326V179.899Z",
    fill: "#A6A6B1",
    fillOpacity: 0.38
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M444.363 188.289L444.258 191.016L357.012 193.427L357.117 188.289H444.363Z",
    fill: "#A6A6B1",
    fillOpacity: 0.38
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M331.11 330.168H334.347L333.732 353.448L331.949 353.238L331.11 330.168Z",
    fill: "white",
    fillOpacity: 0.28
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M334.5 286.5L333.941 303.009V303.114L333.731 309.93H330.481L330.061 297.661L326.496 295.145L326.286 286.546L334.5 286.5Z",
    fill: "white",
    fillOpacity: 0.28
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M334.5 243L334.151 252.57L333.731 266.307H325.867L325.447 243.027L334.5 243Z",
    fill: "white",
    fillOpacity: 0.28
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M334.256 199.404V199.509L333.732 220.377H324.923L324.504 199.404H334.256Z",
    fill: "url(#paint21_linear_1312_18097)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M419.928 221.217L421.292 196.154H371.482L371.167 221.217H419.928Z",
    fill: "#C3C3CF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M371.483 198.566L371.483 222.501L415.211 222.056L416.575 198.566H371.483Z",
    fill: "url(#paint22_linear_1312_18097)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M371.483 197.727H417.309L415.84 222.684L370.959 223.313V222.789L415.211 222.055L416.575 198.565H371.483V197.727Z",
    fill: "#E6E6F0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M403.362 198.566L402.732 222.266H403.362L403.991 198.566H403.362Z",
    fill: "#E6E6F0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M421.292 196.154L417.097 200.768L371.167 204.334L371.482 196.154H421.292Z",
    fill: "#80808D",
    fillOpacity: 0.49
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter2_f_1312_18097)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M371.168 211.674L368.966 231.808L415.211 230.864L416.574 225.516H370.958L371.168 211.674Z",
    fill: "#8C8C95"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M387.736 198.566L387.212 224.153H387.736L388.365 198.566H387.736Z",
    fill: "url(#paint23_linear_1312_18097)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M403.57 210.205L415.839 210.415V209.786L403.57 209.576V210.205Z",
    fill: "url(#paint24_linear_1312_18097)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M423.494 212.093L422.76 225.516H375.467V211.674L423.494 212.093Z",
    fill: "url(#paint25_linear_1312_18097)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M375.468 211.674L371.169 212.827L370.959 226.774L375.468 225.516V211.674Z",
    fill: "#BFBFCB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M375.572 218.385H400.634V222.265L375.467 222.789L375.572 218.385Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M393.295 211.779L394.134 217.966L416.575 218.386V212.094L393.295 211.779Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M371.062 226.774H417.307L422.76 225.516H375.676L371.062 226.774Z",
    fill: "#B3B0BC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M419.928 265.154L420.767 240.092H371.482L371.167 265.154H419.928Z",
    fill: "#C3C3CF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M371.483 242.504L370.959 266.727L415.211 265.993L415.945 242.504H371.483Z",
    fill: "url(#paint26_linear_1312_18097)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter3_f_1312_18097)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M371.168 255.611L368.966 275.745L415.211 274.801L416.574 269.453H370.958L371.168 255.611Z",
    fill: "#8C8C95"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M416.679 241.77H371.483V242.504H415.945L415.595 253.72L403.698 253.516L403.991 242.504H403.362L402.732 266.2L387.777 266.448L388.365 242.504H387.736L387.245 266.457L370.959 266.727V267.356L387.232 267.09L387.212 268.09H387.736L387.761 267.081L415.84 266.622L416.679 241.77ZM403.682 254.145L403.362 266.19L415.211 265.993L415.575 254.349L403.682 254.145Z",
    fill: "#E6E6F0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M423.494 256.031L422.76 269.453H375.467V255.611L423.494 256.031Z",
    fill: "url(#paint27_linear_1312_18097)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M375.468 255.611L371.169 256.87L370.749 270.712L375.468 269.453V255.611Z",
    fill: "#BFBFCB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M375.572 262.322H400.634V266.202L375.467 266.727L375.572 262.322Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M407.975 255.926L407.87 267.985L417.308 268.09L418.671 256.031L407.975 255.926Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M370.959 270.711L375.573 269.453H422.866L411.856 270.607L370.959 270.711Z",
    fill: "#B3B0BC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M425.906 402L429.576 375.68H410.281L413.217 401.266",
    fill: "#FFB4A7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M304.684 366.871L302.797 369.598H357.221L354.494 366.871H304.684Z",
    fill: "url(#paint28_linear_1312_18097)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M488.492 94.157C480.16 97.3868 471.652 94.768 464.109 90.8398C464.021 90.7526 464.021 90.7526 464.109 90.8398C465.688 92.1492 467.179 93.2841 466.828 95.641C466.477 97.8233 464.372 99.22 462.267 99.3073C467.53 102.275 466.214 107.775 462.706 111.878C458.847 116.417 453.584 117.988 447.883 118.599C444.726 118.948 441.48 119.036 438.235 119.297C443.585 123.4 449.988 127.765 446.392 135.709C452.005 127.765 464.635 123.575 470.512 133.526C475.95 142.692 468.231 154.477 460.338 159.278C455.338 162.333 448.497 164.166 442.708 163.031C443.848 165.825 442.445 167.658 440.428 169.229C445.603 172.634 446.655 180.665 444.55 185.99C442.182 192.013 436.744 198.298 431.218 201.528C430.254 202.139 427.885 202.575 427.184 203.186C426.394 203.972 426.482 205.805 425.605 206.853C423.851 209.122 420.606 210.17 417.974 210.868C410.782 212.789 403.678 212.09 396.661 210.083C389.732 208.162 383.066 206.678 376.927 206.853C371.752 207.464 365.7 198.385 364.296 194.283C362.455 188.521 363.419 181.538 368.243 177.522C370.612 175.514 374.295 174.467 377.453 174.641C375.611 173.419 373.681 173.07 372.717 170.888C371.752 168.706 372.015 165.999 372.892 163.817C371.752 162.944 369.471 162.857 369.208 161.024C368.945 159.452 370.612 157.881 372.103 157.881C367.98 156.048 363.419 153.08 361.139 148.715C358.245 143.303 358.245 135.971 361.402 130.733C362.805 128.376 365.086 125.67 367.629 124.622C367.191 121.916 365.788 120.52 366.577 117.29C367.191 114.846 368.682 112.925 369.12 110.568C364.56 107.513 360.437 72.4209 383.242 72.8574C382.715 69.9767 379.996 67.7944 379.733 64.7391C379.558 63.0805 380.347 62.5568 380.347 61.0728C380.347 59.8507 379.733 58.1921 379.47 56.8827C378.242 50.7722 379.207 44.3998 384.294 40.2097C389.118 36.2815 395.609 35.5831 401.573 36.1942C407.625 36.8052 414.027 37.329 419.641 39.5113C425.605 41.8683 433.674 47.2805 434.376 54.1766C435.516 53.1291 437.27 51.7324 438.937 51.5578C440.691 51.2959 441.919 52.1689 443.673 52.1689C445.69 52.1689 447.444 52.0816 449.286 52.8672C451.128 53.6529 452.005 54.9623 453.409 56.0971C463.671 43.876 487.089 41.8683 497 55.2241",
    fill: "url(#paint29_linear_1312_18097)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_i_1312_18097)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M378.299 211.672C378.299 211.672 377.145 209.051 379.977 205.276C382.913 201.5 381.759 197.516 381.759 197.516C381.759 197.516 384.066 198.25 384.486 200.137C384.905 202.025 382.179 203.493 382.703 204.542C383.228 205.59 386.793 204.227 386.269 200.766C385.744 197.306 383.018 185.142 391.721 177.906C391.721 177.906 390.358 185.456 394.658 189.546C398.957 193.636 396.231 197.096 396.231 198.564C396.231 199.613 398.433 199.403 397.699 196.152C396.755 191.853 400.215 191.538 400.215 191.538C400.215 191.538 397.384 196.677 400.949 199.823C403.152 201.71 397.384 206.744 398.013 208.421C398.538 210.099 402.732 209.26 403.047 206.429C403.361 203.703 399.481 197.83 403.047 191.434C403.047 191.434 404.095 197.096 409.758 200.242C415.421 203.388 413.533 207.163 414.896 207.373C416.259 207.583 416.155 201.186 419.405 199.823C419.405 199.823 418.042 202.13 420.244 204.856C422.446 207.583 421.922 212.197 421.922 212.197L378.299 211.672Z",
    fill: "url(#paint30_linear_1312_18097)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_i_1312_18097)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M379.138 211.672C379.138 211.672 377.879 209.68 379.347 207.268C380.92 204.856 382.179 202.339 382.179 202.339C382.179 202.339 382.179 204.436 382.493 205.59C382.808 206.743 381.55 206.848 381.864 207.477C382.179 208.107 383.122 205.8 384.905 204.751C386.688 203.702 388.995 203.073 387.736 198.04C386.478 193.006 386.583 187.553 388.68 184.617C388.68 184.617 389.834 187.449 392.665 190.28C395.496 193.111 393.294 200.242 394.658 201.71C395.916 203.178 396.44 200.242 398.433 199.088C398.433 199.088 399.796 200.766 398.957 203.073C398.118 205.38 394.972 206.743 395.391 208.945C395.811 211.252 401.578 211.672 403.466 209.575C405.354 207.477 402.208 202.654 403.047 199.298C403.047 199.298 405.039 200.871 409.233 202.234C413.428 203.597 411.121 209.784 412.065 210.623C413.113 211.462 415.42 211.148 416.05 208.631C416.679 206.009 416.574 204.122 417.832 202.234C417.832 202.234 418.671 206.114 420.244 208.107C421.817 210.099 418.671 212.091 418.671 212.091L379.138 211.672Z",
    fill: "url(#paint31_linear_1312_18097)"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M384.486 211.672C384.486 211.672 383.123 209.156 384.486 206.744C385.849 204.227 388.366 203.388 388.995 201.501C389.624 199.613 387.632 194.055 389.519 190.805C389.519 190.805 392.35 192.378 393.294 195.733C394.238 199.089 390.148 200.557 389.834 203.074C389.414 205.59 391.826 207.058 393.294 206.22C394.762 205.381 393.609 203.493 396.65 201.606C396.65 201.606 396.021 203.598 396.23 205.59C396.44 207.583 393.189 208.631 393.714 211.777L384.486 211.672Z",
    fill: "url(#paint32_linear_1312_18097)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M407.158 211.911C407.158 211.911 407.39 210.955 407.081 208.259C406.696 204.955 405.231 204.52 405 201.998C405 201.998 406.927 203.911 409.24 205.65C411.552 207.389 407.852 211.998 407.852 211.998L407.158 211.911Z",
    fill: "url(#paint33_linear_1312_18097)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_i_1312_18097)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M391.407 176.334C391.407 176.334 390.777 175.076 391.407 173.817C392.036 172.559 392.455 171.301 392.455 171.301C392.455 171.301 393.504 173.083 393.294 174.447C392.875 175.81 391.407 176.334 391.407 176.334Z",
    fill: "url(#paint34_linear_1312_18097)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_i_1312_18097)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M389.101 177.907C389.101 177.907 389.416 176.439 388.472 176.02C388.367 176.02 387.633 176.754 389.101 177.907Z",
    fill: "url(#paint35_linear_1312_18097)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter8_i_1312_18097)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M404.201 185.666C404.201 185.666 403.676 183.149 405.354 181.576C405.354 181.576 405.354 182.939 405.669 184.303C405.983 185.561 404.201 185.666 404.201 185.666Z",
    fill: "url(#paint36_linear_1312_18097)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter9_i_1312_18097)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M380.291 194.999C380.291 194.999 378.404 194.475 377.46 191.854C377.46 191.854 379.557 192.063 380.291 194.999Z",
    fill: "url(#paint37_linear_1312_18097)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter10_i_1312_18097)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M394.763 169.728C394.553 170.042 394.238 171.406 394.238 172.14C395.497 172.245 396.336 170.777 396.65 169.728C396.231 169.204 395.706 169.099 395.077 169.413L394.763 169.728Z",
    fill: "url(#paint38_linear_1312_18097)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter11_i_1312_18097)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M394.973 163.121C394.973 163.226 394.658 163.331 394.868 163.646C395.392 163.646 395.812 163.436 396.126 163.017C395.812 162.492 395.602 162.702 395.287 162.807L394.973 163.121Z",
    fill: "url(#paint39_linear_1312_18097)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter12_i_1312_18097)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M409.758 164.694C409.758 164.903 409.549 165.323 409.758 165.637C410.073 165.847 410.597 165.637 410.807 165.428C411.121 165.113 411.436 163.855 411.331 163.435C410.387 163.226 409.863 164.274 409.758 165.113V164.694Z",
    fill: "url(#paint40_linear_1312_18097)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter13_i_1312_18097)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M412.379 164.903C412.17 164.169 413.008 164.484 413.008 164.903C413.008 165.532 412.274 165.113 412.274 164.693L412.379 164.903Z",
    fill: "url(#paint41_linear_1312_18097)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter14_i_1312_18097)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M415.631 157.354C415.421 157.459 415.211 157.773 415.316 158.088C416.05 158.193 416.889 157.668 416.05 157.039L415.631 157.354Z",
    fill: "url(#paint42_linear_1312_18097)"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M324.504 220.167C321.987 221.111 318.422 208.213 321.253 205.801C320.729 204.647 320.834 203.179 321.358 202.131C318.108 201.397 315.381 193.742 314.123 188.918C312.759 183.57 312.13 177.383 314.332 172.874C315.486 170.672 310.699 170.762 310.5 168.5C310.371 167.034 312.4 165.381 311.5 163.5C311.124 162.715 310.688 162.073 310.374 161.653C308.171 159.242 306.179 156.515 304.711 152.74C301.775 145.19 301.355 135.857 303.977 128.307C305.235 124.742 307.123 120.862 309.744 120.652C303.872 105.447 313.834 99.9939 320.86 101.777C316.141 97.7917 312.156 92.8631 311.108 83.5303C310.688 79.2309 311.737 75.0364 311.317 70.9467C310.898 67.1716 309.535 64.2355 309.325 60.2507C309.115 55.8464 310.583 52.5956 312.89 50.813C312.366 45.6747 314.253 38.2294 316.351 34.664C319.916 28.7917 327.361 28.3722 332.185 27.743C338.057 27.009 362.244 25.0166 368.222 25.2263C369.69 25.3312 371.472 25.1215 372.94 25.7506C374.723 26.5895 374.723 28.8965 375.038 31.8327C375.772 40.4315 373.884 51.8616 369.795 56.895C371.472 61.0896 371.787 64.5501 371.472 69.3738C372.836 67.0668 375.667 68.0105 377.345 69.5835C379.861 71.8905 381.329 77.4482 382.168 81.9574C384.37 94.0166 380.491 106.6 373.884 110.9C371.367 112.577 367.383 113.731 364.971 110.69C366.649 112.263 372.626 121.386 363.608 125.581C365.39 125.371 366.439 126 367.068 128.831C367.697 131.872 366.858 133.236 366.753 135.857C369.27 137.64 371.158 144.666 371.053 148.965C370.948 151.482 370.004 153.055 369.69 155.257C369.375 157.564 370.004 159.556 370.004 162.073C369.899 170.357 364.446 175.391 360.462 177.907C358.469 179.166 345.477 180.109 343.38 180.739C341.387 181.368 341.387 181.473 341.073 184.723C340.443 191.225 340.024 197.412 337.193 201.397C339.5 205.172 334.571 212.512 333.103 215.134C330.796 219.538 327.965 219.223 324.504 220.167Z",
    fill: "url(#paint43_linear_1312_18097)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter15_i_1312_18097)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M323.036 220.376C323.036 220.376 320.1 214.085 321.358 209.575C322.617 205.066 322.092 203.179 322.092 203.179C322.092 203.179 324.399 205.276 324.714 206.639C325.134 208.002 323.665 208.317 323.665 209.68C323.665 211.044 325.763 210.309 325.763 208.632C325.763 206.954 323.77 205.486 324.19 202.759C324.609 200.138 328.699 198.774 329.643 196.572C330.586 194.37 328.489 193.322 328.594 191.854C328.594 191.854 330.272 192.797 331.95 194.265C333.627 195.733 330.167 196.468 329.223 198.145C328.279 199.823 330.062 203.388 332.264 206.22C334.466 208.946 334.152 209.995 334.152 209.995C334.152 209.995 334.781 207.583 333.942 204.752C333.208 201.92 334.991 201.081 334.991 201.081C334.991 201.081 334.466 202.654 335.83 204.437C337.193 206.22 338.346 215.762 333.837 220.481H323.036V220.376Z",
    fill: "url(#paint44_linear_1312_18097)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter16_i_1312_18097)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M323.56 220.377C323.56 220.377 321.883 218.384 321.463 213.98C321.044 209.576 322.931 206.849 322.931 205.486C322.931 205.486 324.19 206.22 324.19 207.164C324.295 208.108 323.141 208.632 323.351 210.624C323.56 212.617 325.029 213.456 325.972 213.351C326.916 213.246 327.545 210.415 326.182 207.478C324.819 204.542 327.44 200.348 327.44 200.348C327.44 200.348 328.804 204.437 331.74 207.269C334.676 210.1 331.53 217.65 331.74 218.279C331.95 218.908 333.732 217.965 333.732 215.553C333.732 213.036 335.515 208.737 335.515 208.737C335.515 208.737 336.039 211.987 336.249 214.294C336.459 216.601 333.208 220.377 333.208 220.377H323.56Z",
    fill: "url(#paint45_linear_1312_18097)"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M326.077 220.498C326.077 220.498 324.504 218.488 325.133 216.076C325.133 216.076 325.238 217.334 326.077 218.278C326.077 218.278 325.657 214.713 327.545 212.196C329.432 209.679 327.44 206.429 328.698 204.227C328.698 204.227 329.118 207.058 331.215 209.365C333.312 211.672 331.215 220.498 331.215 220.498H326.077Z",
    fill: "url(#paint46_linear_1312_18097)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter17_i_1312_18097)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M330.061 191.12C329.537 191.54 331.11 192.798 331.424 191.645C331.739 191.016 330.166 189.967 330.061 191.12Z",
    fill: "url(#paint47_linear_1312_18097)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter18_i_1312_18097)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M327.649 189.336C327.335 188.916 328.174 188.497 328.278 189.231C328.069 189.441 327.859 189.336 327.649 189.336Z",
    fill: "url(#paint48_linear_1312_18097)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter19_i_1312_18097)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M333.102 174.446C332.263 174.656 334.57 176.019 334.255 174.551C334.045 173.712 332.997 173.712 332.787 174.551L333.102 174.446Z",
    fill: "url(#paint49_linear_1312_18097)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter20_i_1312_18097)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M325.343 189.022C324.714 188.497 325.867 187.868 326.182 188.917C326.496 189.965 325.343 189.756 325.028 189.022H325.343Z",
    fill: "url(#paint50_linear_1312_18097)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter21_i_1312_18097)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M321.567 194.579C321.357 194.998 321.462 195.418 321.777 195.733C322.511 195.418 323.035 194.474 321.987 194.055C321.777 194.16 321.567 194.369 321.567 194.579Z",
    fill: "url(#paint51_linear_1312_18097)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter22_i_1312_18097)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M323.245 193.637C323.245 193.637 323.14 193.742 323.035 193.637C323.559 192.588 324.294 194.161 323.245 193.637Z",
    fill: "url(#paint52_linear_1312_18097)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter23_i_1312_18097)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M336.353 184.618C336.353 185.037 336.248 185.666 336.773 185.876C337.087 185.981 337.717 185.561 337.821 185.247C338.031 184.198 336.773 183.254 336.353 184.618Z",
    fill: "url(#paint53_linear_1312_18097)"
  })))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M423.335 344.746L422.601 358.168H375.308V344.326L423.335 344.746Z",
    fill: "url(#paint54_linear_1312_18097)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M375.309 344.326H371.01L370.8 358.168H375.309V344.326Z",
    fill: "#BFBFCB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M375.413 351.037L386.633 349.988L387.052 358.168H375.308L375.413 351.037Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M393.136 344.432L394.394 354.394L416.415 354.079L417.988 344.746L393.136 344.432Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M420.768 240.092L416.573 244.706L371.272 246.174L371.482 240.092H420.768Z",
    fill: "#80808D",
    fillOpacity: 0.49
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M420.767 285.078L416.573 289.797L371.167 293.362L371.482 285.078H420.767Z",
    fill: "#80808D",
    fillOpacity: 0.49
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M420.767 328.805L416.573 333.419L371.167 336.984L371.482 328.805H420.767Z",
    fill: "#80808D",
    fillOpacity: 0.49
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter24_i_1312_18097)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58 338.779V297.656L147.382 156.818H183.923V212.642H162.723L110.415 295.526V297.23H239.854V338.779H58ZM163.362 375V326.208L164.428 308.203V156.818H213.753V375H163.362Z",
    fill: "#E6E6F0"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter25_i_1312_18097)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M480.531 338.779V297.656L569.913 156.818H606.455V212.642H585.254L532.946 295.526V297.23H662.385V338.779H480.531ZM585.893 375V326.208L586.959 308.203V156.818H636.284V375H585.893Z",
    fill: "#E6E6F0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_1312_18097",
    x: 358.966,
    y: 334.324,
    width: 67.6079,
    height: 40.1328,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "effect1_foregroundBlur_1312_18097"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_1312_18097",
    x: 358.966,
    y: 290.598,
    width: 67.6079,
    height: 40.1328,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "effect1_foregroundBlur_1312_18097"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_1312_18097",
    x: 358.966,
    y: 201.674,
    width: 67.6079,
    height: 40.1328,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "effect1_foregroundBlur_1312_18097"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_1312_18097",
    x: 358.966,
    y: 245.611,
    width: 67.6079,
    height: 40.1328,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "effect1_foregroundBlur_1312_18097"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_i_1312_18097",
    x: 378.066,
    y: 177.906,
    width: 44.9102,
    height: 34.291,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.51 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1312_18097"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_i_1312_18097",
    x: 378.636,
    y: 184.617,
    width: 43.0488,
    height: 27.4746,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.905583 0 0 0 0 0.570833 0 0 0 0.51 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1312_18097"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_i_1312_18097",
    x: 391.127,
    y: 171.301,
    width: 3.19482,
    height: 5.0332,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.905583 0 0 0 0 0.570833 0 0 0 0.51 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1312_18097"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_i_1312_18097",
    x: 388.196,
    y: 176.02,
    width: 1.95557,
    height: 1.88672,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.51 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1312_18097"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_i_1312_18097",
    x: 404.123,
    y: 181.576,
    width: 2.58301,
    height: 4.08984,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.905583 0 0 0 0 0.570833 0 0 0 0.51 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1312_18097"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter9_i_1312_18097",
    x: 377.46,
    y: 191.854,
    width: 3.83154,
    height: 3.14648,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.51 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1312_18097"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter10_i_1312_18097",
    x: 394.238,
    y: 169.236,
    width: 3.41162,
    height: 2.9082,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.51 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1312_18097"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter11_i_1312_18097",
    x: 394.796,
    y: 162.676,
    width: 2.33057,
    height: 0.970703,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.905583 0 0 0 0 0.570833 0 0 0 0.51 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1312_18097"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter12_i_1312_18097",
    x: 409.665,
    y: 163.408,
    width: 2.68652,
    height: 2.31641,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.905583 0 0 0 0 0.570833 0 0 0 0.51 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1312_18097"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter13_i_1312_18097",
    x: 412.274,
    y: 164.463,
    width: 1.73389,
    height: 0.761719,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.905583 0 0 0 0 0.570833 0 0 0 0.51 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1312_18097"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter14_i_1312_18097",
    x: 415.288,
    y: 157.039,
    width: 2.1123,
    height: 1.0625,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.905583 0 0 0 0 0.570833 0 0 0 0.51 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1312_18097"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter15_i_1312_18097",
    x: 321.045,
    y: 191.854,
    width: 17.002,
    height: 28.627,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.51 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1312_18097"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter16_i_1312_18097",
    x: 321.402,
    y: 200.348,
    width: 15.8564,
    height: 20.0293,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.905583 0 0 0 0 0.570833 0 0 0 0.51 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1312_18097"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter17_i_1312_18097",
    x: 329.955,
    y: 190.604,
    width: 2.51074,
    height: 1.51562,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.905583 0 0 0 0 0.570833 0 0 0 0.51 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1312_18097"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter18_i_1312_18097",
    x: 327.579,
    y: 188.83,
    width: 1.69922,
    height: 0.53125,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.905583 0 0 0 0 0.570833 0 0 0 0.51 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1312_18097"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter19_i_1312_18097",
    x: 332.787,
    y: 173.922,
    width: 2.49756,
    height: 1.30078,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.905583 0 0 0 0 0.570833 0 0 0 0.51 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1312_18097"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter20_i_1312_18097",
    x: 325.028,
    y: 188.35,
    width: 2.20752,
    height: 1.28906,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.51 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1312_18097"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter21_i_1312_18097",
    x: 321.458,
    y: 194.055,
    width: 2.11914,
    height: 1.67773,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.51 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1312_18097"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter22_i_1312_18097",
    x: 323.035,
    y: 193.268,
    width: 1.74268,
    height: 0.480469,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.51 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1312_18097"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter23_i_1312_18097",
    x: 336.345,
    y: 183.939,
    width: 2.5,
    height: 1.95312,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.51 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1312_18097"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter24_i_1312_18097",
    x: 58,
    y: 152.818,
    width: 183.854,
    height: 222.182,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: -9
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.878628 0 0 0 0 0.878628 0 0 0 0 0.920833 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1312_18097"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter25_i_1312_18097",
    x: 480.531,
    y: 152.818,
    width: 183.854,
    height: 222.182,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: -9
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.878628 0 0 0 0 0.878628 0 0 0 0 0.920833 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1312_18097"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1312_18097",
    x1: 327.818,
    y1: 332.25,
    x2: 327.818,
    y2: 199.437,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2153,
    stopColor: "#F4FFF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6079,
    stopColor: "#FCFFE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFFFE5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1312_18097",
    x1: 363.517,
    y1: 372.427,
    x2: 363.517,
    y2: 219.398,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2153,
    stopColor: "#F4FFF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6079,
    stopColor: "#FCFFE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFFFE5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1312_18097",
    x1: 423.271,
    y1: 375.643,
    x2: 423.271,
    y2: 208.137,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2153,
    stopColor: "#F4FFF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6079,
    stopColor: "#FCFFE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFFFE5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1312_18097",
    x1: 389,
    y1: 199.5,
    x2: 392.515,
    y2: 160.215,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B8B8C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9811,
    stopColor: "#E3E3EE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1312_18097",
    x1: 373.16,
    y1: 188.289,
    x2: 408,
    y2: 344,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D7E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1312_18097",
    x1: 296.251,
    y1: 367.666,
    x2: 289.455,
    y2: 176.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B8B8C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9811,
    stopColor: "#E3E3EE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1312_18097",
    x1: 330.688,
    y1: 176,
    x2: 394.091,
    y2: 246.401,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CACAD6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1312_18097",
    x1: 329.38,
    y1: 369.598,
    x2: 331.752,
    y2: 394.159,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D7E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1312_18097",
    x1: 289.73,
    y1: 401.994,
    x2: 289.73,
    y2: 369.594,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9946,
    stopColor: "#FFD6BA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1312_18097",
    x1: 327.524,
    y1: 386.979,
    x2: 328.678,
    y2: 375.228,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A9A9C0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1312_18097",
    x1: 331.5,
    y1: 350.499,
    x2: 344.5,
    y2: 203.999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00540541,
    stopColor: "#DADAE6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CACADB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1312_18097",
    x1: 357.231,
    y1: 185.088,
    x2: 451.244,
    y2: 185.088,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00540541,
    stopColor: "#DADAE6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CACADB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_1312_18097",
    x1: 301.964,
    y1: 174.495,
    x2: 359.882,
    y2: 174.495,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00540541,
    stopColor: "#DADAE6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CACADB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_1312_18097",
    x1: 328.584,
    y1: 344.855,
    x2: 330.271,
    y2: 331.419,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A9A9C0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_1312_18097",
    x1: 328.584,
    y1: 301.298,
    x2: 330.286,
    y2: 287.803,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A9A9C0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_1312_18097",
    x1: 328.584,
    y1: 257.714,
    x2: 330.271,
    y2: 244.278,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A9A9C0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_1312_18097",
    x1: 328.584,
    y1: 211.785,
    x2: 330.271,
    y2: 198.348,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A9A9C0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_1312_18097",
    x1: 343.254,
    y1: 366.908,
    x2: 343.254,
    y2: 177.924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B8B8C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9811,
    stopColor: "#C3C3CF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_1312_18097",
    x1: 393,
    y1: 346.499,
    x2: 393.467,
    y2: 332.313,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A9A9C0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_1312_18097",
    x1: 393,
    y1: 302.878,
    x2: 393.467,
    y2: 288.692,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A9A9C0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_1312_18097",
    x1: 375.471,
    y1: 307.561,
    x2: 423.527,
    y2: 307.561,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00540541,
    stopColor: "#DADAE6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CACADB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_1312_18097",
    x1: 329.414,
    y1: 220.414,
    x2: 329.414,
    y2: 199.387,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59427A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C28781"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_1312_18097",
    x1: 393.576,
    y1: 213.667,
    x2: 394.03,
    y2: 199.649,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A9A9C0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_1312_18097",
    x1: 387.187,
    y1: 211.341,
    x2: 388.412,
    y2: 211.341,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9946,
    stopColor: "#FFD6BA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_1312_18097",
    x1: 403.568,
    y1: 210.016,
    x2: 415.891,
    y2: 210.016,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9946,
    stopColor: "#FFD6BA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_1312_18097",
    x1: 375.471,
    y1: 218.585,
    x2: 423.527,
    y2: 218.585,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00540541,
    stopColor: "#DADAE6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CACADB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_1312_18097",
    x1: 393,
    y1: 257.786,
    x2: 393.467,
    y2: 243.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A9A9C0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_1312_18097",
    x1: 375.471,
    y1: 262.522,
    x2: 423.527,
    y2: 262.522,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00540541,
    stopColor: "#DADAE6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CACADB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_1312_18097",
    x1: 330.009,
    y1: 366.871,
    x2: 330.024,
    y2: 368.957,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D7E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_1312_18097",
    x1: 463,
    y1: 64.5,
    x2: 412.473,
    y2: 206.474,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EF4444",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.333419,
    stopColor: "#EF4444",
    stopOpacity: 0.03
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4444",
    stopOpacity: 0.24
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_1312_18097",
    x1: 399.895,
    y1: 165.504,
    x2: 400.419,
    y2: 211.644,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF380D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F36D32"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_1312_18097",
    x1: 390.234,
    y1: 187.569,
    x2: 392.963,
    y2: 212.631,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF640D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F35532"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_1312_18097",
    x1: 387.402,
    y1: 193.058,
    x2: 392.332,
    y2: 211.067,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF810D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.482966,
    stopColor: "#F77126"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F38F32",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_1312_18097",
    x1: 406.379,
    y1: 203.072,
    x2: 409.148,
    y2: 211.38,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF810D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.482966,
    stopColor: "#F77126"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F38F32",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_1312_18097",
    x1: 391.732,
    y1: 171.842,
    x2: 393.282,
    y2: 175.895,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF640D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F35532"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_1312_18097",
    x1: 388.671,
    y1: 175.337,
    x2: 388.744,
    y2: 177.875,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF380D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F36D32"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_1312_18097",
    x1: 404.56,
    y1: 182.016,
    x2: 405.931,
    y2: 185.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF640D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F35532"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_1312_18097",
    x1: 378.867,
    y1: 190.716,
    x2: 378.936,
    y2: 194.948,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF380D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F36D32"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_1312_18097",
    x1: 395.437,
    y1: 168.184,
    x2: 395.506,
    y2: 172.098,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF380D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F36D32"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_1312_18097",
    x1: 395.163,
    y1: 162.78,
    x2: 395.27,
    y2: 163.662,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF640D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F35532"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_1312_18097",
    x1: 410.13,
    y1: 163.657,
    x2: 410.595,
    y2: 165.689,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF640D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F35532"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_1312_18097",
    x1: 412.477,
    y1: 164.545,
    x2: 412.595,
    y2: 165.227,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF640D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F35532"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_1312_18097",
    x1: 415.595,
    y1: 157.153,
    x2: 415.747,
    y2: 158.109,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF640D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F35532"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_1312_18097",
    x1: 356.377,
    y1: 56.7886,
    x2: 268.615,
    y2: 157.67,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EF4444",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.333419,
    stopColor: "#EF4444",
    stopOpacity: 0.03
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4444",
    stopOpacity: 0.24
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_1312_18097",
    x1: 329,
    y1: 181.499,
    x2: 330,
    y2: 219.999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF380D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F36D32"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_1312_18097",
    x1: 325.5,
    y1: 202.499,
    x2: 329.454,
    y2: 220.098,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF640D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F35532"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_1312_18097",
    x1: 326.96,
    y1: 205.975,
    x2: 331.934,
    y2: 219.111,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF810D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.467709,
    stopColor: "#F78A26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F38F32",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_1312_18097",
    x1: 330.372,
    y1: 190.766,
    x2: 330.599,
    y2: 192.128,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF640D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F35532"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_1312_18097",
    x1: 327.772,
    y1: 188.887,
    x2: 327.833,
    y2: 189.371,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF640D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F35532"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_1312_18097",
    x1: 333.2,
    y1: 174.062,
    x2: 333.371,
    y2: 175.238,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF640D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F35532"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_1312_18097",
    x1: 325.629,
    y1: 187.884,
    x2: 325.655,
    y2: 189.617,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF380D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F36D32"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_1312_18097",
    x1: 322.014,
    y1: 193.448,
    x2: 322.064,
    y2: 195.705,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF380D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F36D32"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_1312_18097",
    x1: 323.404,
    y1: 193.094,
    x2: 323.41,
    y2: 193.739,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF380D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F36D32"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_1312_18097",
    x1: 337.09,
    y1: 183.233,
    x2: 337.14,
    y2: 185.86,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF380D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F36D32"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_1312_18097",
    x1: 375.312,
    y1: 351.237,
    x2: 423.368,
    y2: 351.237,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00540541,
    stopColor: "#DADAE6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CACADB"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg404);
export default __webpack_public_path__ + "static/media/404.fc85888f47db98bafacd96246babfdce.svg";
export { ForwardRef as ReactComponent };